<template>
  <div>
    <GenericTopbar :title="title" @close="$emit('close')"/>

    <v-main class="fill-height">
      <slot />
    </v-main>
  </div>
</template>

<script>
import GenericTopbar from '@/components/navigation/GenericTopbar.vue';

export default {
  name: 'GenericLayout',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  components: {
    GenericTopbar,
  },
};
</script>
